import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import CaseStudies from './components/CaseStudies';
import About from './components/About';
import FloatingWidget from './components/FloatingWidget';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <div id="about">
        <About />
      </div>
      <CaseStudies />
      <FloatingWidget />

      {/* Spacer to allow scrolling past the last element */}
      <div style={{ height: '100px' }}></div>
    </div>
  );
}

export default App;
